import { render, staticRenderFns } from "./PersonalInterests.vue?vue&type=template&id=5bf5910a"
import script from "./PersonalInterests.vue?vue&type=script&lang=ts"
export * from "./PersonalInterests.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports